import { AccessControlSettings } from "../../components/admin/service-settings/AccessControlSettings";
import { WeeklySyncSummary } from "../../components/admin/service-settings/WeeklySyncSummary";

export function ServiceSettingsPage() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="h5 mb-2">Access Control</h2>
        <p className="body-sm text-gray-600 dark:text-gray-400">
          Configure which schools can access the B2B platform based on their mybestuser contracts.
        </p>
      </div>

      {/* Bot User Configuration Requirement */}
      <div className="bg-warning-500/10 border border-warning-500 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <div className="text-xl">⚠️</div>
          <div className="flex-1">
            <h3 className="label mb-2 text-warning-400">MyBestUser Bot Configuration Required</h3>
            <p className="caption mb-2 text-warning-300">
              The weekly sync uses an Application bot user in MyBestUser. The agent user document
              must have:
            </p>
            <div className="bg-gray-100 dark:bg-gray-900 border border-warning-500/30 rounded p-3 font-mono caption text-warning-700 dark:text-warning-200 leading-relaxed">
              <div className="text-gray-600 dark:text-gray-500 mb-2">
                {/* MyBestUser users collection - Agent user for Application */}
              </div>
              <div>
                <span className="text-warning-600 dark:text-warning-300">_id:</span>{" "}
                <span className="text-primary-600 dark:text-primary-400">
                  ObjectId('69252003a04554540d187213')
                </span>
              </div>
              <div>
                <span className="text-warning-600 dark:text-warning-300">username:</span>{" "}
                <span className="text-success-600 dark:text-success-400">
                  "application:fed0e2f04e82e71b164c"
                </span>
              </div>
              <div>
                <span className="text-warning-600 dark:text-warning-300">name:</span>{" "}
                <span className="text-success-600 dark:text-success-400">
                  "ai-teach-background-sync Dev"
                </span>
              </div>
              <div className="font-bold bg-warning-500/20 px-1 py-0.5 my-1">
                <span className="text-warning-600 dark:text-warning-300">type:</span>{" "}
                <span className="text-success-600 dark:text-success-400">"bot"</span>{" "}
                <span className="text-error-600 dark:text-error-400 text-[10px]">← REQUIRED</span>
              </div>
              <div className="font-bold bg-warning-500/20 px-1 py-0.5 mb-1">
                <span className="text-warning-600 dark:text-warning-300">role:</span>{" "}
                <span className="text-success-600 dark:text-success-400">"admin"</span>{" "}
                <span className="text-error-600 dark:text-error-400 text-[10px]">← REQUIRED</span>
              </div>
              <div>
                <span className="text-warning-600 dark:text-warning-300">status:</span>{" "}
                <span className="text-success-600 dark:text-success-400">"activated"</span>
              </div>
              <div>
                <span className="text-warning-600 dark:text-warning-300">emailVerified:</span>{" "}
                <span className="text-success-600 dark:text-success-400">false</span>
              </div>
            </div>
            <p className="caption text-warning-700 dark:text-warning-200 mt-2 italic">
              Without this configuration, the weekly sync will fail to authenticate and cannot sync
              schools.
            </p>
          </div>
        </div>
      </div>

      <AccessControlSettings />

      <div className="mt-8">
        <WeeklySyncSummary />
      </div>
    </div>
  );
}
